import script from "./SystemConfigPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemConfigPage.vue?vue&type=script&setup=true&lang=js"

import "./SystemConfigPage.vue?vue&type=style&index=0&id=4d54c804&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d54c804"]])

export default __exports__